const { getStoredValue } = require("../_helpers/storagehelper");
const EnglishData = require("../config/en.json");
const SpanishData = require("../config/es.json");

const ValidationTranslateFile = () => {
  let storedLang = null;

  try {
    storedLang = getStoredValue("lang");
  } catch (e) {
    storedLang = "en";
  }

  switch (storedLang) {
    case "es":
      return SpanishData;
    case "en":
      return EnglishData;
    default:
      return EnglishData;
  }
};

module.exports = ValidationTranslateFile;
